// Mirrors api/src/constants/StationModes.ts - keep the two in sync. A location's mode lives
// in Location.station_config.mode; leaving it unset keeps the location on the corporate
// client's scanner config, exactly as before this field existed (see usefull/station-modes.md).
//
// Member keys are snake_case (matching their own values) to mirror the api enum exactly: its
// GraphQL registration exposes each enum value's wire name as the TS member key, not the
// runtime value, so the two must match or a save here sends a name the api's schema rejects.
export enum StationMode {
  tablet_checkout = 'tablet_checkout',
  hid_checkout = 'hid_checkout',
  boh_address_lookup = 'boh_address_lookup',
  boh_illumia_order = 'boh_illumia_order',
  tablet_return = 'tablet_return',
  hid_return = 'hid_return',
}

export const STATION_MODE_LABELS: Record<StationMode, string> = {
  [StationMode.tablet_checkout]: 'Tablet checkout (V0)',
  [StationMode.hid_checkout]: 'HID checkout (V1)',
  [StationMode.boh_address_lookup]: 'Back of house: address lookup',
  [StationMode.boh_illumia_order]: 'Back of house: Illumia order lookup',
  [StationMode.tablet_return]: 'Tablet return (V0)',
  [StationMode.hid_return]: 'HID return (V1)',
};

// Capability names, matching `capabilities.name`, that the api requires before it will
// accept each mode - see Location.validateStationMode in the api. Duplicated here only so
// the mode dropdown can hide options this location's current capability selection would
// reject; the api is the real gate.
export const STATION_MODE_REQUIRED_CAPABILITY_NAMES: Record<
  StationMode,
  Array<string>
> = {
  [StationMode.tablet_checkout]: ['Checkout Station'],
  [StationMode.hid_checkout]: ['Checkout Station'],
  [StationMode.boh_address_lookup]: ['Checkout Station'],
  [StationMode.boh_illumia_order]: ['Checkout Station', 'Order Ahead'],
  [StationMode.tablet_return]: ['Return Station'],
  [StationMode.hid_return]: ['Return Station'],
};
